define("shared/utils/plans-data/feature-upgrade", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getUpgradeNameFromActions = _exports.getFeatureNameFromList = _exports.featureUpgradeMap = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Maps features to upgrade flows
   * @param intl
   * @returns Popular features per plan type
   */

  const featureUpgradeMap = intl => ({
    additionalAiCreditsOnGrowth: {
      planName: 'growth202506',
      featureName: intl.t('plans.ai_caption_writer.more_ai_credits')
    },
    aiCaptionWriterStarter: {
      planName: 'starter202506',
      featureName: intl.t('plans.ai_caption_writer.more_ai_credits')
    },
    aiCaptionWriterGrowth: {
      planName: 'growth202506',
      featureName: intl.t('plans.ai_caption_writer.more_ai_credits')
    },
    aiCaptionWriterScale: {
      planName: 'scale202506',
      featureName: intl.t('plans.ai_caption_writer.more_ai_credits')
    },
    aiCaptionWriterStarterFromFree: {
      planName: 'starter202506',
      featureName: intl.t('plans.ai_caption_writer.caption_writer')
    },
    aiCaptionWriterGrowthFromFree: {
      planName: 'growth202506',
      featureName: intl.t('plans.ai_caption_writer.caption_writer')
    },
    aiCaptionWriterScaleFromFree: {
      planName: 'scale202506',
      featureName: intl.t('plans.ai_caption_writer.caption_writer')
    },
    collaborators: {
      planName: 'starter202506',
      featureName: intl.t('plans.collaborators')
    },
    groups: {
      planName: 'growth202506',
      featureName: intl.t('plans.groups')
    },
    stories: {
      planName: 'starter202506',
      featureName: intl.t('shared_phrases.schedule_stories')
    },
    searchByHashtag: {
      planName: 'starter202506',
      featureName: intl.t('plans.search_repost')
    },
    searchByProfile: {
      planName: 'starter202506',
      featureName: intl.t('shared_phrases.search_profile')
    },
    textOnImages: {
      planName: 'starter202506',
      featureName: intl.t('plans.text_on_images')
    },
    linkinbioBannerless: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.bannerless')
    },
    linkinbioExtendedClickAnalytics: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.click_analytics')
    },
    linkinbioPaidPlan: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioSeo: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.seo')
    },
    linkinbioUtm: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.utm')
    },
    contributors: {
      planName: 'growth202506',
      featureName: intl.t('shared_words.contributors')
    },
    conversations: {
      planName: 'growth202506',
      featureName: intl.t('plans.conversations')
    },
    analyticsStandard: {
      planName: 'growth202506',
      featureName: intl.t('plans.analytics_standard')
    },
    mentions: {
      planName: 'growth202506',
      featureName: intl.t('plans.mentions')
    },
    tagged: {
      planName: 'growth202506',
      featureName: intl.t('plans.tagged')
    },
    multiPhoto: {
      planName: 'starter202506',
      featureName: intl.t('shared_phrases.multi_photo'),
      upgradeButtonQaClassName: 'qa--carouselUpsell_getMultiPhotoScheduling_Btn'
    },
    unlimitedHashtagSuggestions: {
      planName: 'starter202506',
      featureName: intl.t('plans.unlimited_hashtags')
    },
    bttp: {
      planName: 'starter202506',
      featureName: intl.t('plans.bttp')
    },
    tiktokBttp: {
      planName: 'starter202506',
      featureName: intl.t('plans.tiktok_bttp')
    },
    multiBttp: {
      planName: 'growth202506',
      featureName: intl.t('plans.multi_bttp')
    },
    addMoreMedia: {
      planName: 'starter202506',
      featureName: intl.t('plans.multi_photo_scheduling')
    },
    unlimitedCollectFromTags: {
      planName: 'growth202506',
      featureName: intl.t('plans.unlimited_collect_from_tags')
    },
    userTagging: {
      planName: 'starter202506',
      featureName: intl.t('plans.user_tag')
    },
    igProductTagging: {
      planName: 'growth202506',
      featureName: intl.t('plans.product_tag')
    },
    locationTagging: {
      planName: 'starter202506',
      featureName: intl.t('plans.location_tag')
    },
    firstComment: {
      planName: 'starter202506',
      featureName: intl.t('shared_phrases.first_comment')
    },
    addSocialSets: {
      planName: 'growth202506',
      featureName: intl.t('plans.extra_social_sets')
    },
    addUsers: {
      planName: 'growth202506',
      featureName: intl.t('plans.extra_users')
    },
    twitterClickTracking: {
      planName: 'starter202506',
      featureName: intl.t('plans.twitter_click_tracking')
    },
    twitterAnalytics: {
      planName: 'starter202506',
      featureName: intl.t('plans.twitter_analytics')
    },
    pinterestClickTracking: {
      planName: 'starter202506',
      featureName: intl.t('plans.pinterest_click_tracking')
    },
    pinterestAnalytics: {
      planName: 'starter202506',
      featureName: intl.t('plans.pinterest_analytics')
    },
    performanceReport: {
      planName: 'starter202506',
      featureName: intl.t('plans.performance_report')
    },
    tiktokAnalytics: {
      planName: 'starter202506',
      featureName: intl.t('plans.tiktok_analytics')
    },
    threadsAnalytics: {
      planName: 'starter202506',
      featureName: intl.t('plans.threads_analytics')
    },
    facebookAnalytics: {
      planName: 'starter202506',
      featureName: intl.t('plans.facebook_analytics')
    },
    largerVideos: {
      planName: 'growth202506',
      featureName: intl.t('plans.upload_larger_videos')
    },
    videoCover: {
      planName: 'starter202506',
      featureName: intl.t('plans.select_video_cover')
    },
    autoPublishCarousel: {
      planName: 'starter202506',
      featureName: intl.t('plans.auto_publish_carousel_posts')
    },
    autoHashtags: {
      planName: 'starter202506',
      featureName: intl.t('shared_phrases.hashtag_suggestions_auto')
    },
    searchHashtags: {
      planName: 'starter202506',
      featureName: intl.t('shared_phrases.hashtag_suggestions')
    },
    shareCalendar: {
      planName: 'growth202506',
      featureName: intl.t('plans.share_calendar')
    },
    partnershipSearch: {
      planName: 'growth202506',
      featureName: intl.t('plans.brand_collabs')
    },
    approverRoles: {
      planName: 'growth202506',
      featureName: intl.t('plans.approver_roles')
    },
    calendarNotes: {
      planName: 'growth202506',
      featureName: intl.t('plans.calendar_notes')
    },
    postActivity: {
      planName: 'growth202506',
      featureName: intl.t('plans.post_activity')
    },
    customAnalytics: {
      planName: 'scale202506',
      featureName: intl.t('plans.custom_analytics')
    },
    postTaggingGrowth: {
      planName: 'growth202506',
      featureName: intl.t('plans.post_tagging')
    },
    postTaggingScale: {
      planName: 'scale202506',
      featureName: intl.t('plans.post_tagging')
    },
    // Features below this line have upgrade points that likely lead to dead code (feature has been made available on all plans)
    campaignBoard: {
      planName: 'creator',
      featureName: intl.t('plans.campaign_board')
    },
    mediaKit: {
      planName: 'creator',
      featureName: intl.t('plans.media_kit')
    },
    scheduleReels: {
      planName: 'starter202506',
      featureName: intl.t('plans.highlight_mappings.auto_publish_reels')
    },
    // For features below this line, upgrade points only remain for legacy plans.
    previewGrid: {
      planName: 'starter202506',
      featureName: intl.t('plans.highlight_mappings.auto_publish_reels')
    },
    linkinbioAppBlock: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.mailchimp_for')
    },
    linkinbioButtonBlock: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.button_block')
    },
    linkinbioButtonColors: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.button_colors')
    },
    linkinbioButtonBoxShadow: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.button_shadows')
    },
    linkinbioButtonGroups: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.button_groups')
    },
    linkinbioButtonOutline: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.button_styles')
    },
    linkinbioButtonShape: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.button_shapes')
    },
    linkinbioButtons: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioEmbeddedGallery: {
      planName: 'growth202506',
      featureName: intl.t('plans.linkin_bio.embedded_gallery')
    },
    linkinbioFeaturedBanner: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.featured_banner')
    },
    linkinbioFeaturedMediaCustomImage: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.featured_media_custom_image')
    },
    socialInbox: {
      planName: 'growth202506',
      featureName: intl.t('plans.social_inbox')
    },
    linkinbioFeaturedMediaYouTube: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.featured_media_youtube')
    },
    linkinbioGeneric: {
      planName: 'growth202506',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioHeader: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioMultiLink: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioMultipleFeeds: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioPageBackground: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.page_background')
    },
    linkinbioPageBackgroundImage: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.page_background_image')
    },
    linkinbioPageBlock: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.page_block')
    },
    linkinbioPageFont: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.page_font')
    },
    linkinbioPageText: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.page_text')
    },
    linkinbioPremiumThemes: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.premium_themes')
    },
    linkinbioSocialLinkList: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    linkinbioTiktok: {
      planName: 'starter202506',
      featureName: intl.t('plans.linkin_bio.generic')
    },
    futureTrendsOnCalendar: {
      planName: 'growth202506',
      featureName: intl.t('shared_phrases.future_trends')
    },
    futureTrends: {
      planName: 'scale202506',
      featureName: intl.t('shared_phrases.future_trends')
    },
    // For all features below this line, there are no upgrade points implemented.
    hashtagTrends: {
      planName: 'growth202506',
      featureName: intl.t('plans.hashtag_trends')
    },
    videos: {
      planName: 'starter202506',
      featureName: intl.t('plans.videos')
    }
  });
  _exports.featureUpgradeMap = featureUpgradeMap;
  const getFeatureNameFromList = (intl, feature) => {
    const featureMap = featureUpgradeMap(intl);
    return featureMap[feature]?.featureName ?? '';
  };
  _exports.getFeatureNameFromList = getFeatureNameFromList;
  const getUpgradeNameFromActions = (intl, feature) => {
    const additionalAiCreditFeatures = ['aiCredits', 'aiCreditsOneBundle', 'aiCreditsTwoBundles'];
    if (additionalAiCreditFeatures.includes(feature)) {
      return intl.t('shared_words.credits');
    }
    if (feature == 'user') {
      return intl.t('shared_words.users');
    }
    if (feature == 'socialSet') {
      return intl.t('shared_words.social_sets');
    }
    if (feature == 'getMorePosts') {
      return intl.t('shared_words.posts');
    }
    return '';
  };
  _exports.getUpgradeNameFromActions = getUpgradeNameFromActions;
});